var map = {
	"./caltech.png": 769,
	"./caltech@2x.png": 770,
	"./campridge.png": 771,
	"./campridge@2x.png": 772,
	"./harvard.png": 773,
	"./harvard@2x.png": 774,
	"./mit.png": 775,
	"./mit@2x.png": 776,
	"./oxford.png": 777,
	"./oxford@2x.png": 778,
	"./stanford.png": 779,
	"./stanford@2x.png": 780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 148;